<if-page-view [millisecondInterval]="1500" ifQueryControl="ld">

  <if-page-view-slide>
    <div class="slide_wrap">
      <div class="content">
        <p>{{'Checking if you qualify for special offers...' | trans: 'slide1'}}</p>
        <div class="progress-bar-wrap">
          <span class="progress-bar"></span>
        </div>
      </div>
    </div>
  </if-page-view-slide>

  <if-page-view-slide>
    <div class="slide_wrap">
      <div class="content">
        <p>{{'Congratulations, you are qualified!' | trans: 'slide2'}}</p>
        <div class="progress-bar-wrap">
          <span class="progress-bar progress-step1"></span>
        </div>
      </div>
    </div>
  </if-page-view-slide>

  <if-page-view-slide>
    <div  class="slide_wrap">
      <div class="content">
        <p>{{'Checking for stock...' | trans: 'slide3'}}</p>
        <div class="progress-bar-wrap">
          <span class="progress-bar progress-step2"></span>
        </div>
      </div>
    </div>
  </if-page-view-slide>

  <if-page-view-slide>
    <div  class="slide_wrap">
      <div class="content">
        <p>{{'Stock available!' | trans: 'slide4'}}</p>
        <div class="progress-bar-wrap">
          <span class="progress-bar progress-step3"></span>
        </div>
      </div>
    </div>
  </if-page-view-slide>
  <!-- Empty slide for timing -->
  <if-page-view-slide></if-page-view-slide>
  <!-- /Empty slide for timing -->
</if-page-view>
<if-billing-form #form [defaultSelectedVariant] = "0">

  <div id="wrapper" *ngIf="form.product" class="{{''| trans: 'lang'}}">

      <header>
        <div class="row header-top">
          <div class="container">
            <h5>{{'Your 50% OFF discount has been applied!' | trans: 'discount50applied'}}</h5>
          </div>
        </div>
        <div class="row">
          <div class="logo_wrap">
            <figure class="logo">
              <img [src]="form.getImageSrcByName('logo')" id="prod-logo" />
            </figure>
          </div>
        </div>
      </header>

      <div>
        <div class="container">
          <div class="secure-banner">
            <div class="secure-title">
              <i class="material-icons">verified_user</i>
              <span>{{'Secure Checkout' | trans: 'secureCheckout'}}</span>
            </div>
            <figure class="trust-icons">
              <img src="../../assets/images/trust-icons.svg" />
            </figure>
          </div>

          <ul class="breadcrumbs">
                <li>{{'Checkout' | trans: 'breadcrumbs1'}}</li>
                <li>{{'Bonuses' | trans: 'breadcrumbs2'}}</li>
                <li>{{'Order receipt' | trans: 'breadcrumbs3'}}</li>
          </ul>

          <figure class="product-banner">
            <if-async-image *ngIf="form.getImageSrcByName('banner')"
              [src]="form.getImageSrcByName('banner')"></if-async-image>
          </figure>
        </div>
      </div>

      <div class="container">
        <div class="cols_wrap">
          <div class="col col-form">
            <div class="discount10-appr" *ngIf="showLine">
              {{form.currency}}{{'10' | trans: 'discountAmount'}} {{'OFF coupon has been approved' | trans: 'discountNext'}}
            </div>
            <h5 class="step-title">
              {{'Step' | trans: 'step'}} 1:
              <span>{{'Select order quantity' | trans: 'step1description'}}</span>
            </h5>

            <if-billing-form-product-variant-select [form]="form">
              <ng-template #packageCountryTemplate let-packageCountry="packageCountry" let-isSelected="isSelected">
                <label class="prod-item" [class.selected]="isSelected" *ngIf="form.product" class="{{packageCountry.packageData.bestSeller ? 'featured' : ''}}">
                  <div class="prod-text">
                    <div class="radio-button"></div>
                    <div class="flex_wrap">
                      <span class="units">{{packageCountry.packageData.units}}</span>
                      <span class="productName"> {{form.product.productData.title}} - </span>
                      <span class="productDescription">{{packageCountry.title}}</span>
                    </div>
                  </div>
                  <div class="prod-wrap flex_wrap">
                    <div class="prod-images">
                      <figure *ngFor="let item of [].constructor(packageCountry.packageData.units);let i = index">
                        <img [src]="form.getImageSrcByName('product-image')">
                        <span class="amount">{{packageCountry.packageData.units}}</span>
                      </figure>
                    </div>
                    <div class="price_wrap">
                      <p class="recommended" style="{{packageCountry.packageData.bestSeller ?  '' : 'display:none;'}}">
                        {{'Recommended Deal' | trans: 'recommendDeal'}}
                      </p>
                      <p class="original-price">
                        {{'Reg' | trans: 'reg'}}
                        <span>{{form.currency}}{{packageCountry.originalPrice}}</span>
                      </p>
                      <h6 class="current-price">
                        <span>{{'Only' | trans: 'only'}}</span>
                        <span class="price">{{form.currency}}{{packageCountry.price}}</span>
                      </h6>
                    </div>
                  </div>
                </label>
              </ng-template>
            </if-billing-form-product-variant-select>

            <div class="variants_wrap">
              <if-variant-select *ngIf="form.product" [form]="form" error="{{'Out of stock' | trans: 'stock'}}" itemSelectString="{{'Item' | trans: 'item'}}">
                <ng-template #attributeNameTemplate let-attribute="attribute">
                  <h6 class="variant-title">{{attribute}}</h6>
                </ng-template>
                <ng-template #optionTemplate let-option="option">
                    {{option}}
                </ng-template>
                <ng-template #priceDiffTemplate let-priceDiff="priceDiff">
                  <h6 class="variant-price">{{'Extra:' | trans: 'extra'}}{{form.currency}}{{priceDiff}}</h6>
                </ng-template>
                <ng-template #errorTemplate let-error="error">
                  <h6 class="variant-error">{{error}}</h6>
                </ng-template>
              </if-variant-select>
            </div>

            <div class="total_wrap">
              <div class="total-header flex-space">
                <p>{{'Item' | trans: 'item'}}</p>
                <p>{{'Amount' | trans: 'amount'}}</p>
              </div>
              <div class="total-items flex-space">
                <ul>
                  <li class="flex-space">
                    <p>
                      <span class="productName">{{form.selectedPackageTitle}}</span>
                    </p>
                    <p>
                      {{form.currency}}{{form.cartPrice}}
                    </p>
                  </li>
                  <li>
                    <p class="discount10-appr" *ngIf="showLine">
                      + {{form.currency}} {{'10 Cash Back Coupon for Future Purchase' | trans: 'discount10item'}}
                    </p>
                  </li>
                  <li class="flex-space" *ngIf="form.variantsAdditionalPrice && form.variantsAdditionalPrice != 0">
                    <p>
                      {{'Additional cost:' | trans: 'cost'}}
                    </p>
                    <p>
                      {{form.currency}}{{form.variantsAdditionalPrice}}
                    </p>
                  </li>
                  <li class="flex-space">
                    <p>{{'Shipping' | trans: 'shipping'}}:</p>
                    <p>
                      {{form.currency}}{{form.shippingPrice}}
                    </p>
                  </li>
                </ul>
              </div>
            </div>

            <div class="saved_wrap flex_wrap">
              <div class="saved_title">
                <div>
                  <span>{{'Today You' | trans: 'today'}}</span>
                  <span class="saved">{{'Saved' | trans: 'saved'}}</span>
                  <span class="dollars">{{'$$$' | trans: 'currency'}}</span>
                </div>
              </div>
              <div class="text">
                <h5 class="discount">
                  {{'Discount' | trans: 'discountTotal'}}: <span>-{{form.currency}}{{form.discount}}</span>
                </h5>
                <h5 class="total">
                  {{'Grand total' | trans: 'grandTotal'}}: <span> {{form.currency}}{{form.totalPrice}}</span>
                </h5>
              </div>
            </div>
            <figure class="col-banner">
              <if-async-image *ngIf="form.getImageSrcByName('bottom-banner')"
                [src]="form.getImageSrcByName('bottom-banner')"></if-async-image>
            </figure>
          </div>

          <div class="col col-form">
            <div class="step" id="scrollTarget">
              <h5 class="step-title">
                {{'Step' | trans: 'step'}} 2:
                <span>{{'Payment Method' | trans: 'step2description'}}</span>
              </h5>
              <div class="form-secure-banner">
                <div class="secure-title">
                  {{'Your Card is Securely Processed By' | trans: 'cardProcessed'}}:
                </div>
                <figure class="trust-icons">
                  <img src="../../assets/images/payment-icons.svg" />
                </figure>
              </div>

              <if-sticky position="top" class="open-forms" >
                <div class="button_wrap hide-desktop">
                  <button type="button" class="sticky-button" [class.hide]="isHideButton"
                  (click)="showFormMobile()">{{'Checkout' | trans: 'buttonCheckout'}}
                  </button>
                </div>
                <ng-template #stickyPart>
                  <div class="button_wrap sticky-button_wrap" ifScrollTo="scrollTarget">
                    <button  type="button" class="sticky-button" [class.hide]="isHideButton"
                      (click)="showFormMobile()">{{'Checkout' | trans: 'buttonCheckout'}}
                    </button>
                  </div>
                </ng-template>
              </if-sticky>

              <!-- embed payment -->
              <div class="form hidden-form" [class.show-form]="isShowForm">
                <div class="cc-title">
                  <p>{{'Credit Card Information' | trans: 'cCardInfo'}}:</p>
                  <figure>
                    <img src="../../assets/images/paypal_creditcard_images.png" />
                  </figure>
                </div>
                <div id="payment-form">
                  <div class="if-billing-form">
                    <if-billing-form-input class="cc-input" [form]="form" type="number" maxlength="16" minlength="14"
                      name="cardNumber" error="{{'Please, enter valid card number' | trans: 'cardNumberError'}}" required="true"
                      label="{{'Credit card number' | trans: 'cardNumber'}}">
                      <i class="material-icons" prefix>lock</i>
                      <div class="cc-image {{form.creditCardType}}" [ngStyle]="{ 'background-image': 'url(assets/images/cards/card-' + (form.creditCardType || 'blank') + '.jpg)'}" postfix></div>
                    </if-billing-form-input>
                    <if-billing-form-input [form]="form" type="number" maxlength="4" name="cvvCode" required=""
                      autocomplete="off" label="{{'CVV code' | trans: 'cvvCode'}}" error="{{'Please, enter a valid cvv code' | trans: 'cvvCodeError'}}">
                      <span class="cvv-info" postfix>
                        <span class="cvv-icon">?</span>
                        <div class="cvv-exp">
                          <div class="container">
                            <p>{{'The security code is a three digit number, located on the back of any Visa ® or MasterCard ® on the right side of the signature strip as illustrated.' | trans: 'cvvInfo'}}</p>
                            <figure>
                              <if-async-image src="../assets/images/cards/cvvex.png"></if-async-image>
                            </figure>
                          </div>
                        </div>
                      </span>
                    </if-billing-form-input>

                    <div class="exp-date flex-space">
                      <p>{{'Expiration' | trans: 'expiration'}}: </p>
                      <div class="form_group">
                        <if-billing-form-select [form]="form" name="expirationMonth" placeholder="{{'Month' | trans: 'expMonth'}}"
                          [required]="true" error="{{'Select month' | trans: 'expMonthError'}}" [options]="form.creditCardMonthOptions">
                          <ng-template #optionTemplate let-month="option">{{
                            month.month + "-" + month.name
                           }}</ng-template>
                        </if-billing-form-select>
                      </div>
                      <div class="form_group">
                        <if-billing-form-select [form]="form" name="expirationYear" placeholder="{{'Year' | trans: 'expYear'}}"
                          [required]="true" error="{{'Select year' | trans: 'expYearError'}}" [options]="form.creditCardYearsOptions">
                          <ng-template #optionTemplate let-year="option">{{
                            year
                           }}</ng-template>
                        </if-billing-form-select>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- /embed payment -->
              </div>
            </div>

            <div class="step hidden-form" [class.show-form]="isShowForm">
              <h5 class="step-title">
                {{'Step' | trans: 'step'}} 3:
                <span>{{'Customer Information' | trans: 'customerInfo'}}</span>
              </h5>

              <div class="form">
                <!-- embed details -->
                <div id="full-details-form">
                  <if-billing-form-input [form]="form" label="{{'Email Address' | trans: 'email'}}" name="email" type="email"
                    required="true" autocomplete="off" error="{{'Enter a valid email' | trans: 'emailError'}}">
                  </if-billing-form-input>

                  <hr>

                  <if-billing-form-input [form]="form" label="{{'Full Name' | trans: 'fullName'}}" name="fullName" type="text"
                    required="true" autocomplete="off" error="{{'Enter a full name' | trans: 'fullNameError'}}">
                  </if-billing-form-input>

                  <if-billing-form-mobile-flag-input [form]="form" placeholder="{{'Phone number' | trans: 'phone'}}" error="{{'Enter a valid phone number' | trans: 'phoneError'}}">
                    <!-- selected label (on the left) template -->
                    <ng-template #labelTemplate let-option="option">
                      <img *ngIf='option.code2' [src]="'../assets/flags/' + option.code2.toLowerCase() + '.svg'"/>
                      <span>+ {{option.number}}</span>
                    </ng-template>
                    <ng-template #optionTemplate let-option="option">
                    <!-- drop down item template -->
                      <div class="countries">
                        <span class="flags">
                          <img [src]="'../assets/flags/' + option.code2.toLowerCase() + '.svg'"/>
                        </span>
                        <span class="country-name">{{option.name}} +{{option.number}}</span>
                      </div>
                    </ng-template>
                  </if-billing-form-mobile-flag-input>

                  <if-billing-form-input [form]="form" label="{{'Street' | trans: 'street'}}" name="street" type="text"
                    required="true" autocomplete="off" error="{{'Enter a delivery street' | trans: 'streetError'}}">
                  </if-billing-form-input>

                  <if-billing-form-input [form]="form" label="{{'Street Number' | trans: 'streetNumber'}}" name="streetNumber" type="text"
                    required="true" autocomplete="off" error="{{'Enter a delivery street number' | trans: 'streetNumberError'}}">
                  </if-billing-form-input>
                  
                  <if-billing-form-input [form]="form" label="{{'City' | trans: 'city'}}" name="city" type="text" required="true"
                    autocomplete="off" error="{{'Enter a valid city name' | trans: 'cityError'}}"></if-billing-form-input>

                  <if-billing-form-country-select [form]="form" name="country" label="Country" placeholder="{{'Country' | trans: 'country'}}"
                    [required]="true">
                  </if-billing-form-country-select>

                  <div class="flex-space half">
                    <if-billing-form-state-select [form]="form" name="state"
                      placeholder="{{'State/Province' | trans: 'state'}}" [required]="false" error="Select state">
                    </if-billing-form-state-select>

                    <if-billing-form-input [form]="form" label="{{'Zip code' | trans: 'zipCode'}}" name="zip" type="text"
                      required="true" autocomplete="off" maxlength="20" error="{{'Enter a valid zip code' | trans: 'zipCodeError'}}">
                    </if-billing-form-input>
                  </div>
                </div>
                <!-- /embed details -->

                <if-sticky position="top">
                  <!-- this will be shown regardless -->
                  <div class="button_wrap">
                    <button type="submit" class="button" (click)="form.billingForm.ngSubmit.emit()">
                      {{'Yes, Send mine now!' | trans: 'buttonSend'}}
                    </button>
                  </div>
                  <!-- #stickyPart template will stick to top when button out of screen -->
                  <ng-template #stickyPart>
                  <div class="button_wrap sticky-button_wrap">
                    <button type="submit" class="button" (click)="form.billingForm.ngSubmit.emit()">
                      {{'Yes, Send mine now!' | trans: 'buttonSend'}}
                    </button>
                  </div>
                  </ng-template>
                </if-sticky>
              </div>
            </div>

            <div class="safe-checkout">
              {{'Guaranteed' | trans: 'guaranteeSafe1'}}
              <span>{{'safe' | trans: 'guaranteeSafe2'}}</span>
              {{'checkout' | trans: 'guaranteeSafe3'}}
            </div>

            <figure class="trust-icons">
              <if-async-image src="../../assets/images/trust-icons2.svg">
                <ng-template #imagePlaceholder>
                  <div></div>
                </ng-template>
              </if-async-image>
            </figure>

            <div class="money-back flex-space">
              <figure>
                <img src="../../assets/images/money-back.png" />
              </figure>
              <p>
                <span>{{'30 day guarantee' | trans: 'guarantee30'}}:</span> &nbsp;
                {{'We offers a 30 day guarantee on all unused purchases. Simply send the item(s) back to us in the original unopened packaging for a full refund or replacement, less S&amp;H.' | trans: 'guarantee30text'}}
              </p>
            </div>
          </div>
        </div>
      </div>



      <!-- on success order -->
      <ng-template #orderSuccessDialogTemplate let-response="response">
        <div id="overlay"></div>
        <div class="modal">
          <i class="material-icons close-modal">close</i>
          <div class="container">
            <h3 class="discount-title">{{'Congratulations!' | trans: 'congratulations'}}</h3>
            <div class="discount-text">
              <h5>{{'Your order is on the way' | trans: 'orderSended'}}</h5>
              <h5>{{'Order Id' | trans: 'orderId'}}: {{response.orderId}}</h5>
            </div>
          </div>
        </div>
      </ng-template>

      <!-- loader -->
      <ng-template #loaderTemplate>
        <div id="overlay"></div>
        <div class="modal process_wrap">
          <div class="container">
            <div class="title">
              <h4 class="text-primary">{{'Thank you for your purchase!' | trans: 'thankYou'}}</h4>
              <h5>{{'Your order is being processed' | trans: 'orderProcessed'}}</h5>
              <h5>{{'Do not refresh or close your browser' | trans: 'notRefresh'}}</h5>
            </div>

            <div class="process-steps">
              <if-page-view [millisecondInterval]="4000">
                <if-page-view-slide>
                  <span class="check"></span>
                  <h5>{{'Connecting to credit card processors' | trans: 'processStep1'}}</h5>
                  <span class="step-bar"></span>
                </if-page-view-slide>
                <if-page-view-slide>
                  <span class="check"></span>
                  <h5>{{'Verifying Your Payment Information' | trans: 'processStep2'}}</h5>
                  <span class="step-bar"></span>
                </if-page-view-slide>
                <if-page-view-slide>
                  <span class="check"></span>
                  <h5>{{'Your Transaction is being Processed' | trans: 'processStep3'}}</h5>
                  <span class="step-bar"></span>
                </if-page-view-slide>
              </if-page-view>
            </div>
          </div>
        </div>
      </ng-template>

      <!-- error -->
      <ng-template #orderFailedDialogTemplate let-close="close" let-error="error">
        <div id="overlay"></div>
        <div class="modal error process-failed">
          <span class="close-modal" (click)="close()"></span>
          <div class="container">
        <h5 class="discount-title">
          {{error.message | trans: 'orderErrorMessage' || "{{'Your transaction had been declined' | trans: 'transactionDeclined'}}"}}
        </h5>
        <h5>{{error.description || ""}}</h5>
            <p>
              {{'For any additional information' | trans: 'anyInformation'}}<br />
              {{'Contact our' | trans: 'contactOur'}}
              <a class="text-primary" href="{{form.supportLink}}">{{'support' | trans: 'support'}}</a><br />
              {{'Or email us' | trans: 'emailUs'}}:
              <a class="text-primary" href="mailto:{{form.supportEmail}}">{{
                form.supportEmail
              }}</a>
            </p>
            <button type="button" class="button" (click)="close()">OK</button>
          </div>
        </div>
      </ng-template>

      <!-- on user leave screen dialog -->
      <if-exit-dialog ifQueryControl="ep">
        <ng-template #dialogTemplate let-close="close">
          <div id="overlay" (click)="close()"></div>
          <div class="discount10 modal">
            <span class="close-modal" (click)="close()"></span>
            <div class="container">
              <h3 class="discount-title">{{'Winner' | trans: 'winner'}}!</h3>
              <div class="discount-text">
                <h5>
                  {{form.currency}}{{'10 OFF next purchase' | trans: 'discount10text'}}</h5>
              </div>
              <div class="buttons_wrap">
                <button type="button" class="yes-btn" (click)="showLine=true; close()">
                  <if-translation transKey="yesButton">
                    <div>
                      <span>I want &nbsp;</span>
                      {{form.currency}}10 Off Now!
                    </div>

                  </if-translation>
                </button>
                <button type="button" class="no-btn" (click)="close()">
                  <if-translation transKey="noButton">
                    <div>
                      No, I Don't Want<br />
                      this Great Deal
                    </div>
                  </if-translation>

                </button>
              </div>
            </div>
          </div>
        </ng-template>
      </if-exit-dialog>

      <!--Purchase notification-->
      <if-purchase-notifications
        [form]="form"
        [initialSecondDelayRange]="[1, 1]"
        [intervalSecondRange]="[10, 15]"
        [displaySecondDuration]="5"
        ifQueryControl="nt"
        >
        <ng-template #notificationTemplate let-note="notification">
          <div id="recentBox">
            <figure id="recentImg">
              <img [src]="form.getImageSrcByName('product-image')"/>
            </figure>
            <div id="recentText">
              <div class="text">
                <span id="randFirst">{{note.firstName}}</span>
                <span id="randLast"> {{note.letter}}</span
                >. {{'from' | trans: 'notificationFrom'}} <span id="randLocation">{{note.city}}</span>
                <br />
                {{'just purchased' | trans: 'notificationPurchase'}}
                <span class="prodTitle">{{form.product.productData.title}}</span>
              </div>
            </div>
          </div>
        </ng-template>
      </if-purchase-notifications>

      <section class="comments_wrap" ifQueryControl="cm">
        <div class="container">
          <if-testimonials [form]="form" dateFormat="dd/MM/yyyy">
            <ng-template #testimonialTemplate let-testimonial="testimonial">
              <div class="user">
                <figure>
                  <img src="{{testimonial.image}}" />
                </figure>
                <div class="user-info">
                  <p>{{testimonial.author}}
                    <span>{{testimonial.place}}</span>
                  </p>
                </div>
              </div>
              <p>
                {{testimonial.testimonial}}
              </p>
              <div class="comment-footer">
                <span class="like">{{'Like' | trans: 'like'}}</span>
                <span class="reply">{{'Reply' | trans: 'reply'}}</span>
                <span>12</span>
                <span class="date">{{testimonial.date}}</span>
              </div>
            </ng-template>
          </if-testimonials>
        </div>
      </section>

      <section class="faq_wrap">
        <div class="faq-title" (click)=toggleDisplayFaq()>
          <p>{{'Have a question' | trans: 'faqTitle1'}}?<span>{{'See our FAQs' | trans: 'faqTitle2'}}</span></p>
        </div>
        <div id="faq" [hidden]="isShowFaq">
          <if-product-faq [form]="form">
            <div class="product-placeholder" loader></div>
          </if-product-faq>
        </div>
      </section>

      <footer>
        <div class="container">
          <p class="footer-details no-select">
            © <span>{{currentyear | date:'yyyy'}}</span> - {{form.companyDetails.companyName}}
          </p>
          <ul class="links_wrap">
            <li [ifPopupButton]="terms">{{'Terms &amp; Conditions' | trans: 'terms'}}</li>
            <li [ifPopupButton]="privacy">{{'Privacy policy' | trans: 'privacy'}}</li>
            <li [ifPopupButton]="ccpa" [hidden]="!form.formGroup.get('country').value || form.formGroup.get('country').value.code2 != 'US' " >CCPA</li>
            <li [ifPopupButton]="impressum" [hidden]="!form.formGroup.get('country').value || form.formGroup.get('country').value.code2 != 'DE' " >Impressum</li>
            <li><a href="https://konelix.com/" target="_black">{{'Affiliates' | trans: 'affiliates'}}</a></li>
          </ul>
          <ul class="footer-details company-details no-select">
            <li>{{form.companyDetails.supportNumber}}</li>
            <li>{{form.companyDetails.supportEmail}}</li>
            <li>{{form.companyDetails.companyAddress}}</li>
          </ul>
        </div>
        <div class="badge">
          <a href="https://www.dmca.com/Protection/Status.aspx?ID=aa6604d1-1880-4110-a1a8-75579910d347&amp;refurl=https://checkout.thetrendzoo.com/billing/billing1/index.html?camp=5082&amp;theme=properfocus1&amp;clickid=GiCL5EnAmGnAngGuiKeQXnW244E5QR9J1qX6ZT_PJH4hCiCRxVE&amp;pub=Taboola~nbcuniversal-msnbc&amp;extra=Optix_US_Dsk_RON_14.10&amp;sub_pub_id=1012083&amp;rd=co&amp;tblci=GiCL5EnAmGnAngGuiKeQXnW244E5QR9J1qX6ZT_PJH4hCiCRxVE&amp;country=US&amp;hash=hbHwUjpHE78P9Z+oz0QPwMTbgE0kKOWYpXXRT3Mru/2qMH4Zm9v6FYe2AaN3UF1dchncQHkljXr0wq6x1MzxQtrHqWy+zoI9zeTtwwUPPXvGHayMZFL1MQsVWqRQ1mQETZuxEed4jjDVXJYMs3JnlFHvpBmZiwSMV2kppPW1tr0dYYuvRY1CQ81g0rL39Jp1aMO+ROf3V5IzrOeieT++ZZzV+XyDxo8m/1XxfsJnhkc=&amp;productNum=5730499526813"
            title="DMCA.com Protection Status" class="dmca-badge" target="_blank">
            <img src="https://images.dmca.com/Badges/dmca_protected_sml_120m.png?ID=aa6604d1-1880-4110-a1a8-75579910d347"
              alt="DMCA.com Protection Status" />
          </a>
          <script src="https://images.dmca.com/Badges/DMCABadgeHelper.min.js"></script>
        </div>
      </footer>

      <div class="legal_wrap">
        <ng-template #terms let-close="close">
          <div id="overlay" (click)="close()"></div>
          <div class="privacy-modal">
            <span class="close-modal" (click)="close()"></span>
            <app-terms  [form]="form"></app-terms>
          </div>
        </ng-template>
        <ng-template #privacy let-close="close">
          <div id="overlay" (click)="close()"></div>
          <div class="privacy-modal">
            <span class="close-modal" (click)="close()"></span>
            <app-privacy  [form]="form"></app-privacy>
          </div>
        </ng-template>
        <ng-template #ccpa let-close="close">
          <div id="overlay" (click)="close()"></div>
          <div class="privacy-modal">
            <span class="close-modal" (click)="close()"></span>
            <app-ccpa  [form]="form"></app-ccpa>
          </div>
        </ng-template>
        <ng-template #impressum let-close="close">
          <div id="overlay" (click)="close()"></div>
          <div class="privacy-modal impressum-modal">
            <span class="close-modal" (click)="close()"></span>
            <app-impressum  [form]="form"></app-impressum>
          </div>
        </ng-template>
      </div>
    </div>
</if-billing-form>

